module.exports = __webpack_public_path__ + "static/media/step2img7.8a3b099b.JPG";